import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _aa75f110 = () => interopDefault(import('../pages/actions/index.vue' /* webpackChunkName: "pages/actions/index" */))
const _59269a47 = () => interopDefault(import('../pages/brands/index.vue' /* webpackChunkName: "pages/brands/index" */))
const _2cf5ee9b = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _891228d8 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _286993e0 = () => interopDefault(import('../pages/collections/index.vue' /* webpackChunkName: "pages/collections/index" */))
const _09319af8 = () => interopDefault(import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */))
const _f3cb8d40 = () => interopDefault(import('../pages/compare/index.vue' /* webpackChunkName: "pages/compare/index" */))
const _1676a9c6 = () => interopDefault(import('../pages/delete-account/index.vue' /* webpackChunkName: "pages/delete-account/index" */))
const _ab522836 = () => interopDefault(import('../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _62cb6508 = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _5004bea9 = () => interopDefault(import('../pages/info/index.vue' /* webpackChunkName: "pages/info/index" */))
const _f7d40238 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _6cad7485 = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _2d1d3a8e = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _bef686ee = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _029d01bb = () => interopDefault(import('../pages/personal/index.vue' /* webpackChunkName: "pages/personal/index" */))
const _3aa3e042 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _236bf0ad = () => interopDefault(import('../pages/stores/index.vue' /* webpackChunkName: "pages/stores/index" */))
const _660a7576 = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _74d41476 = () => interopDefault(import('../pages/company/about/index.vue' /* webpackChunkName: "pages/company/about/index" */))
const _fd78fa40 = () => interopDefault(import('../pages/company/contacts/index.vue' /* webpackChunkName: "pages/company/contacts/index" */))
const _655262e7 = () => interopDefault(import('../pages/company/requisites/index.vue' /* webpackChunkName: "pages/company/requisites/index" */))
const _66135862 = () => interopDefault(import('../pages/order/pay/index.vue' /* webpackChunkName: "pages/order/pay/index" */))
const _08762146 = () => interopDefault(import('../pages/order/pay-error/index.vue' /* webpackChunkName: "pages/order/pay-error/index" */))
const _1b3aa806 = () => interopDefault(import('../pages/order/pay-ok/index.vue' /* webpackChunkName: "pages/order/pay-ok/index" */))
const _8beb4b8e = () => interopDefault(import('../pages/personal/bonuses/index.vue' /* webpackChunkName: "pages/personal/bonuses/index" */))
const _0bdfb962 = () => interopDefault(import('../pages/personal/orders/index.vue' /* webpackChunkName: "pages/personal/orders/index" */))
const _b3bba056 = () => interopDefault(import('../pages/personal/profile/index.vue' /* webpackChunkName: "pages/personal/profile/index" */))
const _c668dede = () => interopDefault(import('../pages/personal/orders/__id/index.vue' /* webpackChunkName: "pages/personal/orders/__id/index" */))
const _d90843f0 = () => interopDefault(import('../pages/actions/__id/index.vue' /* webpackChunkName: "pages/actions/__id/index" */))
const _3e80b499 = () => interopDefault(import('../pages/brands/__id/index.vue' /* webpackChunkName: "pages/brands/__id/index" */))
const _6456ef7c = () => interopDefault(import('../pages/catalog/__slug/index.vue' /* webpackChunkName: "pages/catalog/__slug/index" */))
const _558d2180 = () => interopDefault(import('../pages/collections/__slug/index.vue' /* webpackChunkName: "pages/collections/__slug/index" */))
const _ec35ced8 = () => interopDefault(import('../pages/help/__slug/index.vue' /* webpackChunkName: "pages/help/__slug/index" */))
const _249e6ac7 = () => interopDefault(import('../pages/info/__slug/index.vue' /* webpackChunkName: "pages/info/__slug/index" */))
const _1653ae9c = () => interopDefault(import('../pages/news/__id/index.vue' /* webpackChunkName: "pages/news/__id/index" */))
const _3bbafe01 = () => interopDefault(import('../pages/products/__id/index.vue' /* webpackChunkName: "pages/products/__id/index" */))
const _f3a1241a = () => interopDefault(import('../pages/stores/__id/index.vue' /* webpackChunkName: "pages/stores/__id/index" */))
const _d0901bec = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/actions",
    component: _aa75f110,
    name: "actions"
  }, {
    path: "/brands",
    component: _59269a47,
    name: "brands"
  }, {
    path: "/cart",
    component: _2cf5ee9b,
    name: "cart"
  }, {
    path: "/catalog",
    component: _891228d8,
    name: "catalog"
  }, {
    path: "/collections",
    component: _286993e0,
    name: "collections"
  }, {
    path: "/company",
    component: _09319af8,
    name: "company"
  }, {
    path: "/compare",
    component: _f3cb8d40,
    name: "compare"
  }, {
    path: "/delete-account",
    component: _1676a9c6,
    name: "delete-account"
  }, {
    path: "/favourites",
    component: _ab522836,
    name: "favourites"
  }, {
    path: "/help",
    component: _62cb6508,
    name: "help"
  }, {
    path: "/info",
    component: _5004bea9,
    name: "info"
  }, {
    path: "/login",
    component: _f7d40238,
    name: "login"
  }, {
    path: "/logout",
    component: _6cad7485,
    name: "logout"
  }, {
    path: "/news",
    component: _2d1d3a8e,
    name: "news"
  }, {
    path: "/order",
    component: _bef686ee,
    name: "order"
  }, {
    path: "/personal",
    component: _029d01bb,
    name: "personal"
  }, {
    path: "/products",
    component: _3aa3e042,
    name: "products"
  }, {
    path: "/stores",
    component: _236bf0ad,
    name: "stores"
  }, {
    path: "/video",
    component: _660a7576,
    name: "video"
  }, {
    path: "/company/about",
    component: _74d41476,
    name: "company-about"
  }, {
    path: "/company/contacts",
    component: _fd78fa40,
    name: "company-contacts"
  }, {
    path: "/company/requisites",
    component: _655262e7,
    name: "company-requisites"
  }, {
    path: "/order/pay",
    component: _66135862,
    name: "order-pay"
  }, {
    path: "/order/pay-error",
    component: _08762146,
    name: "order-pay-error"
  }, {
    path: "/order/pay-ok",
    component: _1b3aa806,
    name: "order-pay-ok"
  }, {
    path: "/personal/bonuses",
    component: _8beb4b8e,
    name: "personal-bonuses"
  }, {
    path: "/personal/orders",
    component: _0bdfb962,
    name: "personal-orders"
  }, {
    path: "/personal/profile",
    component: _b3bba056,
    name: "personal-profile"
  }, {
    path: "/personal/orders/:_id",
    component: _c668dede,
    name: "personal-orders-_id"
  }, {
    path: "/actions/:_id",
    component: _d90843f0,
    name: "actions-_id"
  }, {
    path: "/brands/:_id",
    component: _3e80b499,
    name: "brands-_id"
  }, {
    path: "/catalog/:_slug",
    component: _6456ef7c,
    name: "catalog-_slug"
  }, {
    path: "/collections/:_slug",
    component: _558d2180,
    name: "collections-_slug"
  }, {
    path: "/help/:_slug",
    component: _ec35ced8,
    name: "help-_slug"
  }, {
    path: "/info/:_slug",
    component: _249e6ac7,
    name: "info-_slug"
  }, {
    path: "/news/:_id",
    component: _1653ae9c,
    name: "news-_id"
  }, {
    path: "/products/:_id",
    component: _3bbafe01,
    name: "products-_id"
  }, {
    path: "/stores/:_id",
    component: _f3a1241a,
    name: "stores-_id"
  }, {
    path: "/",
    component: _d0901bec,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
